import React, { useContext, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { InputLabel, FormHelperText, FormControlLabel, Checkbox } from '@material-ui/core';
import { SecondaryButton, SingelSelect } from '../../../../Core/FormInput';
import AppContext from '../../../../App/AppContext';
import { getMADashboardCategoryDropdown } from '../../../../Core/Service/ManageAccount/maDashboard-Category-service';
import { postMAMappingCategory_AddNominalAccount } from '../../../../Core/Service/ManageAccount/mappingCategoryModal-service';

function AccountLinkModal({ accountCode, onClose }) {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [reverseSign, setReverseSign] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { showToast } = useContext(AppContext);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await getMADashboardCategoryDropdown();
                setCategories(res.data.maMappingCategory || []);
            } catch (err) {
                showToast('Failed to load categories');
            }
        };
        fetchCategories();
    }, [showToast]);

    const handleMappingCategory = (name) => (event, value) => {
        setSelectedCategory(value);
        setError('');
    };

    const handleSubmit = async () => {
        if (!selectedCategory) {
            setError('Please select a category');
            return;
        }
    
        setLoading(true);
        try {
            const payload = {
                MAMappingCategoryID: selectedCategory.id,
                AccountCode: [accountCode],
                ReverseSign: reverseSign
            };
    
            const res = await postMAMappingCategory_AddNominalAccount(payload);
            
            if (res.success) {
                showToast('Account linked successfully');
                onClose(true);
            } else {
                showToast(res.message || 'Failed to link account');
                onClose();
            }
        } catch (err) {
            showToast('Error linking account');
            onClose();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <InputLabel shrink>Category List</InputLabel>
                <SingelSelect
                    options={categories}
                    value={selectedCategory}
                    onChange={handleMappingCategory('category')}
                    getOptionLabel={(option) => option.name || ''}
                    getOptionSelected={(option, value) => option.id === value?.id}
                />
                {error && <FormHelperText error>{error}</FormHelperText>}
            </Grid>

            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={reverseSign}
                            onChange={(e) => setReverseSign(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Reverse Sign?"
                />
            </Grid>

            <Grid item xs={12}>
                <SecondaryButton 
                    onClick={handleSubmit}
                    disabled={loading}
                    isBtnLoader={loading}
                    fullWidth
                >
                    Link Account
                </SecondaryButton>
            </Grid>
        </Grid>
    );
}

export default AccountLinkModal;